<div class="container section">
    <div class="row pagetitle-row">
        <div class="pagetitle">
            <div class="nav-icons aboutme">
                <i class="fa fa-chevron-up fa-2x" aria-hidden="true"></i>
            </div>
            <h1 class="aboutme">Personal Information</h1>
        </div>
    </div>
    <form class="full-width" novalidate (ngSubmit)="save()" [formGroup]="personalInfoForm">
        <div id='aboutme'>
            <h3>About Me</h3>
            <div class="row">
                <div class="col-md-12 privacy-url">
                    We take protection of your personal information seriously. See more about how your information is used in our <a target="_blank" [href]="ui_PrivacyURL">Privacy Policy</a>.
                </div>
            </div>
            <div class="row FlowupLabels">
                <div class="col-md-12">
                    <!-- (keypress)="selectKeyPress($event, ui_Prefix, 'Prefix', personalInfoForm)" -->
                    <!-- <mat-form-field>
                <mat-select placeholder="Prefix" formControlName="prefix">
                  <mat-option *ngFor="let p of ui_Prefix" [value]="p.value">
                    {{ p.label }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="personalInfoForm.get('prefix').errors?.required">
                  <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
                </mat-error>
                </mat-form-field> -->
                    <div class="validationwrap"
                        [class.validation-error]="prefix.invalid && (prefix.dirty || prefix.touched || formSubmitted)">
                        <div class="fl_wrap">
                            <label class="fl_label">Prefix</label>
                            <select class="fl_input" FlowUpLabel formControlName="prefix">
                                <!-- <option value=""></option> -->
                                <option *ngFor="let obj of ui_Prefix" [disabled]="obj.label.indexOf(']') > -1"
                                    [value]="obj.value">{{obj.label}}</option>
                            </select>
                            <span class="validationhead">
                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field>
                        <input matInput placeholder="First Name" formControlName="firstName">
                        <mat-error *ngIf="personalInfoForm.get('firstName').errors?.required">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field>
                        <input matInput placeholder="Middle Name" formControlName="middleName">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field>
                        <input matInput placeholder="Last Name" formControlName="lastName">
                        <mat-error *ngIf="personalInfoForm.get('lastName').errors?.required">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field>
                        <input matInput placeholder="Suffix" formControlName="suffix">
                    </mat-form-field>
                </div>
            </div>

            <div class="row FlowupLabels">
                <div class="col-md-12">
                    <div class="fl_wrap">
                        <label class="fl_label">Pronouns</label>
                        <select class="fl_input" FlowUpLabel formControlName="pronoun">
                            <option value=""></option>
                            <option *ngFor="let obj of ui_Pronouns" [value]="obj.value">{{obj.label}}</option>
                        </select>
                    </div>
                </div>
            </div>


            <div class="row">
                <div class="col-md-12">
                    <mat-form-field>
                        <input matInput placeholder="Professional Credentials" formControlName="jobTitle">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field>
                        <input matInput placeholder="NPI Number" formControlName="npi" maxlength="10">
                        <mat-error>
                            <span *ngIf="npi.errors?.pattern">
                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Invalid NPI Number
                            </span>
                            <span *ngIf="npi.errors?.tokenTaken">
                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> NPI Number exists
                            </span>

                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="dob datepicker">
                        <input matInput [matDatepicker]="dob" (click)="dob.open()" placeholder="Date of Birth"
                            formControlName="dateOfBirth">
                        <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
                        <mat-datepicker #dob disabled="false"></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row FlowupLabels">
                <div class="col-md-12">
                    <div class="fl_wrap">
                        <label class="fl_label">Gender/Gender Identity</label>
                        <select class="fl_input" FlowUpLabel formControlName="gender">
                            <option value=""></option>
                            <option *ngFor="let obj of ui_Gender" [value]="obj.value">{{obj.label}}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row FlowupLabels">
                <div class="col-md-12">
                    <div class="fl_wrap">
                        <label class="fl_label">Sexual Orientation</label>
                        <select class="fl_input" FlowUpLabel formControlName="sexualOrientation">
                            <option value=""></option>
                            <option *ngFor="let obj of ui_SexualOrientations" [value]="obj.value">{{obj.label}}</option>
                        </select>
                    </div>
                </div>
            </div>


            <div class="row FlowupLabels">
                <div class="col-md-12">
                    <div class="fl_wrap">
                        <label class="fl_label">Race/Ethnicity</label>
                        <select class="fl_input" FlowUpLabel formControlName="ethnicity">
                            <option value=""></option>
                            <option *ngFor="let obj of ui_Ethnicity" [value]="obj.value">{{obj.label}}</option>
                        </select>
                    </div>
                </div>
            </div>


            <div class="row FlowupLabels">
                <div class="col-md-12">
                    <div class="fl_wrap">
                        <label class="fl_label">Primary Language</label>
                        <select class="fl_input" FlowUpLabel formControlName="primaryLanguage">
                            <option value=""></option>
                            <option *ngFor="let obj of ui_PrimaryLanguages" [value]="obj.value">{{obj.label}}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row FlowupLabels">
                <div class="col-md-12">
                    <div class="fl_wrap">
                        <label class="fl_label">Disability</label>
                        <select class="fl_input" FlowUpLabel formControlName="disability">
                            <option value=""></option>
                            <option *ngFor="let obj of ui_Disabilities" [value]="obj.value">{{obj.label}}</option>
                        </select>
                    </div>
                </div>
            </div>


        </div>




        <div id='aboutmyCareer'>
            <h3>About My Career</h3>

            <div class="row FlowupLabels">
                <div class="col-md-12">
                    <div class="fl_wrap">
                        <label class="fl_label">Primary Practice Geography</label>
                        <select class="fl_input" FlowUpLabel formControlName="primaryPracticeGeography">
                            <option value=""></option>
                            <option *ngFor="let obj of ui_PrimaryPracticeGeography" [value]="obj.value">{{obj.label}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>


            <div class="row FlowupLabels">
                <div class="col-md-12">
                    <div class="fl_wrap">
                        <label class="fl_label">Primary Practice Setting</label>
                        <select class="fl_input" FlowUpLabel formControlName="primaryPracticeSetting">
                            <option value=""></option>
                            <option *ngFor="let obj of ui_PrimaryPracticeSettings" [value]="obj.value">{{obj.label}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>


            <div class="row FlowupLabels">
                <div class="col-md-12">
                    <div class="validationwrap"
                        [class.validation-error]="primaryReasonForJoining.invalid && (primaryReasonForJoining.dirty || primaryReasonForJoining.touched || formSubmitted)">

                        <div class="fl_wrap">
                            <label class="fl_label">What's your primary reason for joining?</label>
                            <select class="fl_input" FlowUpLabel formControlName="primaryReasonForJoining">
                                <option value=""></option>
                                <option *ngFor="let obj of ui_PrimaryReasonForJoining" [value]="obj.value">{{obj.label}}
                                </option>
                            </select>
                        </div>

                        <span class="validationhead">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required</span>


                    </div>
                </div>
            </div>



        </div>










        <div id='primary'>
            <h3>Primary Contact</h3>
        </div>
        <div formGroupName="customerAddress">
            <div class="row FlowupLabels">
                <div class="col-md-12">
                    <div class="validationwrap"
                        [class.validation-error]="addressType.invalid && (addressType.dirty || addressType.touched || formSubmitted)">
                        <div class="fl_wrap">
                            <label class="fl_label">Address Type</label>
                            <select class="fl_input" FlowUpLabel formControlName="addresstype"
                                (change)="refreshAddress()">
                                <option value="Home">Home</option>
                                <!-- <option value="Hospital">Hospital</option> -->
                                <option value="Business">Business</option>
                            </select>
                            <span class="validationhead">
                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required</span>
                        </div>
                    </div>
                </div>
            </div>
            <app-address [address]="personalInfoForm.get('customerAddress.address')"
                [HIDEORG]="addressType.value == 'Home'">
            </app-address>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field>
                    <input matInput placeholder="Email" formControlName="email">
                    <mat-error>
                        <span *ngIf="email.errors?.required">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
                        </span>
                        <span *ngIf="email.errors?.email">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Invalid Email
                        </span>
                        <span *ngIf="email.errors?.tokenTaken">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Email exists
                        </span>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field>
                    <input matInput placeholder="Mobile Phone" formControlName="phone">
                    <mat-error *ngIf="personalInfoForm.get('phone').errors?.required">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row actions">
            <div class="col-md-12">
                <button mat-raised-button class="btnSave">Save and Continue</button>
            </div>
        </div>
    </form>
    <pre *ngIf="isDevEnv"><code>
    {{ personalInfoForm.value | json }}
   {{ memberAppDataService.memberAppData.addresses | json }}
  </code></pre>
</div>